// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

export interface IErrorContext {
  enqueueError: (error: Error) => void;
}
export const ErrorContext = React.createContext({} as IErrorContext);
export const useErrorContext = () => React.useContext(ErrorContext);
